import { requestJson } from "@/lib/api";
import type { Supplier } from "@/lib/types";

interface SupplierDto {
  id: string;
  name: string;
  cnpj?: string | null;
  phone?: string | null;
  notes?: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

function toSupplier(dto: SupplierDto): Supplier {
  return {
    id: dto.id,
    name: dto.name,
    cnpj: dto.cnpj ?? null,
    phone: dto.phone ?? null,
    notes: dto.notes ?? null,
    active: dto.active,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
}

export async function fetchSuppliers(): Promise<Supplier[]> {
  const list = await requestJson<SupplierDto[]>("/api/v1/admin/suppliers");
  return list.map(toSupplier);
}

export async function fetchSupplier(id: string): Promise<Supplier> {
  return toSupplier(await requestJson<SupplierDto>(`/api/v1/admin/suppliers/${id}`));
}

export async function createSupplier(input: {
  name: string;
  cnpj?: string;
  phone?: string;
  notes?: string;
}): Promise<Supplier> {
  return toSupplier(await requestJson<SupplierDto>("/api/v1/admin/suppliers", {
    method: "POST",
    body: input,
  }));
}

export async function updateSupplier(id: string, input: {
  name: string;
  cnpj?: string;
  phone?: string;
  notes?: string;
}): Promise<Supplier> {
  return toSupplier(await requestJson<SupplierDto>(`/api/v1/admin/suppliers/${id}`, {
    method: "PUT",
    body: input,
  }));
}

export async function deactivateSupplier(id: string): Promise<void> {
  await requestJson<void>(`/api/v1/admin/suppliers/${id}`, { method: "DELETE" });
}
